import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import { PATHS } from '@/routes/paths';
import { Loader } from '@/components/custom/loader';
import { DashboardSummaryCard } from './dashboard-summary-card';
import { useSession } from '@/hooks/useSession';
import { DashboardQuickActions } from './dashboard-quick-actions';
import Breadcrumbs from '@/components/custom/breadcrumbs/breadcrumbs';
import { DashboardReportShortcut } from './dashboard-report-shortcut';
import { WarningWallSlider, WarningWall } from '@/components/custom/warning-wall';
import { DashboardSection, DashboardSectionTitle, DashboardSummaryWrapper } from '@/components/custom/dashboard';

export function DashboardMetrics() {
  const client = useClient();
  const { session } = useSession();
  const [loading, setLoading] = useState(true);
  const [cards, setCards] = useState([]);
  const [mostVisited, setMostVisited] = useState([]);
  const [banners, setBanners] = useState();

  const getCards = async () => {
    setLoading(true);
    const { data, errors } = await client.fetch(`dashboards/kpis`);

    if (errors) {
      toast.error('Erro ao buscar informações dos cards.');
    } else {
      setCards(
        data?.data?.map((card, index) => ({
          ...card,
          id: index
        }))
      );
    }
    setLoading(false);
  };

  const getMostVisited = async () => {
    const { data, errors } = await client.fetch(`route_logs/most_visited`);

    if (errors) {
      toast.error('Erro ao buscar rotas mais acessadas.');
    } else {
      setMostVisited(data?.data);
    }
  };

  const fetchData = () => {
    setLoading(true);
    const fetchBanners = client.fetch(`/bulletin_boards/active`);

    let promises = [fetchBanners];

    Promise.allSettled(promises).then(([bannersResponse]) => {
      if (bannersResponse?.value?.error) {
        toast.error('Erro ao buscar banners');
      } else {
        setBanners(bannersResponse?.value?.data);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    getCards();
    getMostVisited();
    fetchData();
  }, []);

  const breadCrumbs = {
    title: 'Início',
    nav: [
      {
        route: '/',
        name: `Olá, ${session?.user?.name}`,
        isActive: true
      }
    ]
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Breadcrumbs data={breadCrumbs} />

      {loading ? (
        <Loader />
      ) : banners?.length > 1 && !loading ? (
        <WarningWallSlider data={banners} />
      ) : (
        !loading && (
          <WarningWall
            loading={loading}
            warning={banners?.[0]}
            key={banners?.[0]?.id}
          />
        )
      )}

      <DashboardQuickActions mostVisited={mostVisited} />

      <DashboardSummaryWrapper>
        {cards?.map(card => (
          <DashboardSummaryCard
            title={card?.label}
            count={card?.value}
            key={card?.id}
          />
        ))}
      </DashboardSummaryWrapper>

      <DashboardSection>
        <DashboardSectionTitle>Relatórios mais acessados</DashboardSectionTitle>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <DashboardReportShortcut
            link={PATHS.REPORTS.COURSE_PROGRESS}
            icon="monitor"
            title="Progresso dos Cursos"
          />
          <DashboardReportShortcut
            link={PATHS.REPORTS.REGISTRATION}
            icon="users"
            title="Cadastros"
          />
          <DashboardReportShortcut
            link={PATHS.REPORTS.ACCESS_FUNNEL}
            icon="funil"
            title="Funil de acessos"
          />
          <DashboardReportShortcut
            link={PATHS.REPORTS.ACCESS}
            icon="pointer"
            title="Mapeamento de acessos"
          />
        </div>
      </DashboardSection>
    </>
  );
}
